"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _xApiStatementFactory = _interopRequireDefault(require("./xApi/xApiStatementFactory"));

var _TrackingService = _interopRequireDefault(require("./services/TrackingService"));

var _EventService = _interopRequireDefault(require("./services/EventService"));

var _configOptions = require("./constants/config-options");

var _defaultConfig = require("./config/default-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AmpEvents =
/*#__PURE__*/
function () {
  /** Initialize the module with the given configuration options.
   *
   * @param {Object} config
   * @param {String} config.appName The name of the app that will send events.
   * @param {String} config.appVersion The version of the app that will send events.
   * @param {String} config.language The language in which xAPI events will be sent (i.e. en-US).
   * @param {String} config.environment The environment in which the app is running (i.e. devci, prod).
   * @param {String} config.userId The id for the logged in user, which will be attached to all events created with
   *                 EventService or TrackingService.
   */
  function AmpEvents(config) {
    _classCallCheck(this, AmpEvents);

    this.config = Object.assign({}, _defaultConfig.defaultConfig, config);
    this.eventFactory = new _xApiStatementFactory["default"](this.config, this.config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT]);
    this._eventService = new _EventService["default"](this.config);
  }
  /**
   * Expose instance of EventService with a getter so that we can prevent its usage if configuration is invalid.
   *
   * @return {EventService?}
   */


  _createClass(AmpEvents, [{
    key: "startTrackingEvents",

    /**
     * Start capturing and sending generic xAPI events.
     *
     * @param {Object?} trackingConfig Optional tracking config options to use, else will use defaults.
     * @param {Boolean} trackingConfig.autoUnload Whether event tracking should automatically stop on window unload.
     *         Default is true.
     * @param {Boolean} trackingConfig.trackAppLoad Whether to track app load events. Default is true.
     * @param {Boolean} trackingConfig.trackAppUnload Whether to track app unload events. Default is true.
     * @param {Boolean} trackingConfig.stashAppUnloadEvent Whether to stash, rather than to immediately send, app
     *         unload events. Stashed events will be sent the next time the user loads the app and AmpEvents is
     *         initialized. Stashing helps prevent events from being lost if the app unloads before an event can be
     *         sent. Default is true.
     * @param {Boolean} trackingConfig.trackPageOpen Whether to track page open events. Default is true.
     * @param {Boolean} trackingConfig.trackPageClose Whether to track page close events. Default is true.
     * @param {Boolean} trackingConfig.stashFinalPageCloseEvent Whether to stash, rather than to immediately send, the
     *         final page closed event when event tracking is stopped. The stashed event will be sent the next time the
     *         user loads the app and AmpEvents is initialized. This should help ensure that the event will not be lost
     *         if there's not time to send it (i.e. if the app is unloading). Default is true.
     * @param {Boolean} trackingConfig.trackPagesByHashChange Whether to listen for hashchange events on the window
     *         for page view tracking. Appropriate for single-page apps using hash-based routing. This replaces the
     *         default page tracking behavior, which polls for location updates. Default is false.
     */
    value: function startTrackingEvents(trackingConfig) {
      if (!this.config || !this.config[_configOptions.CONFIG_OPTIONS.APP_NAME] || !this.config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
        throw new Error("AmpEvents must be configured with ".concat(_configOptions.CONFIG_OPTIONS.APP_NAME, " and ") + "".concat(_configOptions.CONFIG_OPTIONS.USER_ID, " options in order to track events"));
      }

      this.trackingService = new _TrackingService["default"](this._eventService, trackingConfig);
      this.trackingService.start();
    }
    /**
     * Stop capturing and sending generic xAPI events.
     */

  }, {
    key: "stopTrackingEvents",
    value: function stopTrackingEvents() {
      if (this.trackingService) {
        this.trackingService.stop();
      }
    }
  }, {
    key: "eventService",
    get: function get() {
      if (!this.config || !this.config[_configOptions.CONFIG_OPTIONS.APP_NAME] || !this.config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
        throw new Error("AmpEvents must be configured with ".concat(_configOptions.CONFIG_OPTIONS.APP_NAME, " and ") + "".concat(_configOptions.CONFIG_OPTIONS.USER_ID, " options in order to use the EventService"));
      }

      return this._eventService;
    }
  }]);

  return AmpEvents;
}();

AmpEvents.OPTIONS = _configOptions.CONFIG_OPTIONS;
AmpEvents.TRACKING_OPTIONS = _configOptions.TRACKING_OPTIONS;
AmpEvents.ENVIRONMENTS = _configOptions.ENVIRONMENTS;
var _default = AmpEvents;
exports["default"] = _default;
module.exports = exports.default;